import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import Graphic from "./graphic";
import ModalManager from "../../components/modals/ModalManager";
import CookieCat from "../../../components/accept-cookies/banner";
import Footer from "./footer";
import { jsQueries } from "../../components/mediaquery/breakpoints";
import Media from "react-media";
import PageTitle from "../../utils/page-title";

const MainContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: auto;
  position: relative;
`;

const Content = styled.div`
  width: 380px;
  max-width: 100%;
  max-height: 100%;
  padding: 20px 5px;
  text-align: left;
`;

const StyledH1 = styled.h1`
  color: ${cloud.getShade(10)};
  font-weight: 400;
  line-height: 1;
  font-size: 2.6rem;
`;

const ContainerLayout = ({
  graphic,
  graphicBookCover,
  title,
  children,
  pageTitle
}) => {
  return (
    <MainContainer>
      <CookieCat />
      <PageTitle title={pageTitle} />

      <FlexContainer>
        <Media query={jsQueries.small}>
          {matches =>
            matches ? null : (
              <Graphic page={graphic} bookCover={graphicBookCover} />
            )
          }
        </Media>
        <Content>
          <StyledH1 id="user-page-title">{title}</StyledH1>
          {children}
        </Content>
      </FlexContainer>
      <Footer />
      <ModalManager />
    </MainContainer>
  );
};

ContainerLayout.propTypes = {
  children: PropTypes.node,
  graphic: PropTypes.string,
  graphicBookCover: PropTypes.string,
  pageTitle: PropTypes.string,
  title: PropTypes.node
};

export default ContainerLayout;
